export default ({
  LOYALTY_CLUB: 'سفینه تپسی',
  STORE: 'فروشگاه',
  HELP: 'راهنما',
  PLANET: '',
  TRIP: 'سفر',
  PURCHASES: 'خریدهای من',
  PURCHASE: 'خرید',
  REGISTER: 'ثبت‌نام',
  STARS: 'ستاره‌های من',
  STAR: 'ستاره',
  SUM_STARS: 'مجموع ستاره‌ها',
  GIFT: '',
  ENTER_LOYALTY: 'ورود به سفینه',
  GENDER: 'جنسیت',
  MALE: 'مرد',
  FEMALE: 'زن',
  SEASON_END_TIME: 'اقامتگاه تا پایان',
  CURRENT_POSITION: 'موقعیت کنونی',
  LAND: 'سطح ',
  EARTH: 'زمین',
  MOON: 'ماه',
  SUN: 'خورشید',
  GALAXY: 'کهکشان',
  CHOOSE_DESTINATION: 'تعیین مقصد',
  LESS_ITEMS: 'موارد کمتر',
  MORE_ITEMS: 'موارد بیشتر',
  BEST_GIFTS: 'محصولات منتخب فروشگاه',
  TRAVELS_TO_REACH: ' سفر تا رسیدن به ',
  PASSED_SUCCESSFULLY: 'با موفقیت پشت سر گذاشتید',
  HAVENT_REACHED_YET: function (name) { return `برای رسیدن به ${this[name]} آماده باشید` },
  SITE_URL: 'آدرس سایت',
  VOUCHER_EXPIRATION: 'فرصت استفاده از این کد تخفیف',
  UNTIL_THE_END: 'تا پایان',
  HOW_TO_USE: 'نحوه استفاده',
  PURCHASE_DATE: 'تاریخ خرید',
  EXPIRATION_DATE: 'تاریخ انقضا',
  BY_USING_THIS_PRODUCT: 'با خرید این محصول',
  COMMA: '، ',
  SCORE_WILL_BE_SUBTRACTED: 'ستاره از حساب شما کسر خواهد شد و قابل بازگشت نیست',
  ARE_YOU_SURE: 'آیا مطمئن هستید؟',
  ERROR_MESSAGE: 'خطایی در انجام درخواست شما رخ داده است',
  INSUFFICIENT_STARS: 'ستاره‌های شما برای خرید کافی نیست',
  BACK: 'بازگشت',
  YES: 'بله',
  NO: 'خیر',
  BACK_TO_STORE: 'بازگشت به فروشگاه',
  SHOW_PRODUCT: 'نمایش محصول',
  SCORE_IS_SUBTRACTED: 'ستاره از حساب شما کسر شد',
  PURCHASE_SUCCEEDED: 'خرید با موفقیت انجام شد',
  GIFT_IS_ADDED: 'محصول شما به لیست «خریدهای من» افزوده شد',
  REGISTER_TITLE: 'مشخصاتتان را این‌جا وارد کنید و دکمهٔ ثبت‌نام را بزنید',
  BIRTH_DATE: 'تاریخ تولد',
  REGISTER_LEGAL: {
    "1": 'با ثبت‌نام در کهکشان تپسی با ',
    "2": 'قوانین',
    "3": ' آن موافق هستید'
  },

  SUBMIT: 'تایید',
  CANCEL: 'لغو',
  GIFT_CODE: 'کد شما',
  COPY: 'کپی کردن',
  COPIED: 'کپی شد',
  YOU_REACHED_GALAXY: 'شما کهکشان را فتح کردید',
  HELP_CAPTION: 'همهٔ اطلاعات لازم، قوانین و مقررات و پاسخ به پرسش‌های متداول را این‌جا بخوانید',
  EXPAND: 'جزئیات بیشتر',
  CURRENT_PLANET_MOTO: [
    'این',
    'را در',
    'هستید',
  ],
  SPRING: 'بهار',
  SUMMER: 'تابستان',
  AUTUMN: 'پاییز',
  WINTER: 'زمستان',
  MONTHS: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'],
  PRODUCT_IS_ADDED_TO_VOUCHERLIST: 'محصول به لیست تخفیف‌ها افزوده شد',
  LEVELS: 'سطوح',
  TIERS_HINT: 'راهنمای دریافت ستاره و شرایط هر  یک از سیاره ها',
  VIEW_LEVELS: 'مشاهده سطوح',
})
